/** Router selection follows the document URL, independently of authentication. */
export function getRouterBasename(pathname: string): string {
  return /^\/dashboard(?:\/|$)/.test(pathname) ? '/dashboard' : '/';
}

/** Old patient bookmarks retain their feature path, query and fragment. */
export function legacyPatientTarget(pathname: string, search: string, hash: string): string | null {
  if (!/^\/dashboard\/p(?:\/|$)/.test(pathname)) return null;
  const path = pathname.replace(/^\/dashboard/, '');
  return `${path === '/p' || path === '/p/' ? '/' : path}${search}${hash}`;
}
